var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommission(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3552_126793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.835 91.1983H30.2514C34.4633 91.1983 38.7205 91.6372 42.8197 92.4817C50.0707 93.9755 57.7052 94.1565 65.0306 92.9707C68.6425 92.386 72.1935 91.4921 75.4078 89.9406C78.3095 88.5401 81.8639 86.566 84.2513 84.3547C86.6354 82.1467 89.1182 78.5329 90.8805 75.7082C92.3916 73.286 91.6607 70.3142 89.2705 68.5094C86.6154 66.5046 82.6754 66.505 80.0209 68.5103L72.4909 74.1985C69.5726 76.403 66.3848 78.4323 62.5874 79.038C62.1308 79.1109 61.6523 79.1772 61.1531 79.2351M61.1531 79.2351C61.0028 79.2525 60.8507 79.2691 60.6967 79.2849M61.1531 79.2351C61.7606 79.1049 62.3638 78.7303 62.9298 78.2363C65.6098 75.8972 65.7793 71.9551 63.4539 69.3431C62.9144 68.7371 62.283 68.2317 61.5811 67.813C49.9255 60.8611 31.7909 66.1559 20.835 73.9256M61.1531 79.2351C61.0011 79.2676 60.8487 79.2849 60.6967 79.2849M60.6967 79.2849C58.516 79.5088 55.9648 79.5667 53.134 79.2994",
    stroke: "#D5DEE5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.33496,
    y: 64.5801,
    width: 12.5,
    height: 33.3333,
    rx: 5,
    stroke: "#D5DEE5",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6719 11.3281L36.3281 38.6719",
    stroke: "#D5DEE5",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2578 19.1406C41.9545 19.1406 44.1406 16.9545 44.1406 14.2578C44.1406 11.5611 41.9545 9.375 39.2578 9.375C36.5611 9.375 34.375 11.5611 34.375 14.2578C34.375 16.9545 36.5611 19.1406 39.2578 19.1406Z",
    stroke: "#D5DEE5",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7422 40.625C63.4389 40.625 65.625 38.4389 65.625 35.7422C65.625 33.0455 63.4389 30.8594 60.7422 30.8594C58.0455 30.8594 55.8594 33.0455 55.8594 35.7422C55.8594 38.4389 58.0455 40.625 60.7422 40.625Z",
    stroke: "#D5DEE5",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3552_126793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommission);
export default __webpack_public_path__ + "static/media/commission.1bd839d946be6bfa4f37749b7ecde418.svg";
export { ForwardRef as ReactComponent };